import { CREATE_NOTATION, DELETE_NOTATION, UPDATE_NOTATION } from '../constants/actionTypes.js'

export default (notations = [], action) => {
    switch(action.type){
        case CREATE_NOTATION:
            return [...notations, action.payload]
        case UPDATE_NOTATION:
            return notations.map(gf => gf._id === action.payload._id ? action.payload : gf)
        case DELETE_NOTATION:
            return notations.filter(gf => gf._id !== action.payload)
        default :
            return notations
    }
}